import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import KEYS from '../../common/keyCodes';
import AddressBarMiniToolbar from './addressBarMiniToolbar.js';
import BaseButton from '../button/button';
import { DismissBold, ConfirmBold } from '../../icons';
import TextInput from '../textInput/textInput';
var isButton = function isButton(target) {
  if (target) {
    var predicate = function predicate(className) {
      return _.includes(['editable-url-btn-cancel', 'editable-url-btn-apply'], className);
    };
    return _.some(target.classList, predicate);
  }
};
var EditableUrl = /*#__PURE__*/function (_React$Component) {
  function EditableUrl(props) {
    var _this;
    _classCallCheck(this, EditableUrl);
    _this = _callSuper(this, EditableUrl, [props]);
    _this.state = {
      isValid: true,
      isFocused: false,
      valueCandidate: props.value,
      isReadOnly: props.editButtons && !props.autoSelect || props.isReadOnly
    };
    _this.setStateWithReadOnly = function (nextIsReadOnly) {
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _.noop;
      var useNextIsReadOnly = _this.props.editButtons;
      var func = function func(_ref) {
        var isReadOnly = _ref.isReadOnly,
          isFocused = _ref.isFocused;
        var isReadOnlyState = {
          isReadOnly: useNextIsReadOnly ? nextIsReadOnly : isReadOnly,
          isFocused: nextIsReadOnly === true ? false : isFocused
        };
        return _.assign(isReadOnlyState, nextState);
      };
      _this.setState(func, callback);
    };
    _this.onChange = function () {
      _this.props.onChange(_this.state.valueCandidate);
    };
    _this.getClassNames = function () {
      var defaultName = 'control-editable-url';
      var focus = _this.state.isFocused ? ' focus' : '';
      var editButtons = _this.props.editButtons ? ' with-edit-buttons' : '';
      return _this.props.getClassName(defaultName + focus + editButtons);
    };
    _this.handleEdit = function () {
      _this.setStateWithReadOnly(false);
      _this.props.onEditClick();
    };
    _this.handleCandidateChange = function (valueCandidate) {
      var callback = _.partial(_this.props.onValueCandidateChange, valueCandidate);
      _this.setState({
        valueCandidate: valueCandidate
      }, callback);
    };
    _this.handleValidationStatusChange = function (isValid) {
      var callback = _.partial(_this.props.onValidationStatus, isValid);
      _this.setState({
        isValid: isValid
      }, callback);
    };
    _this.handleBlur = function (_ref2) {
      var relatedTarget = _ref2.relatedTarget;
      var validationOK = _this.state.isValid || _this.props.allowInvalidChange;
      var alreadyHandled = _this.alreadyHandled || isButton(relatedTarget);
      _this.alreadyHandled = false;
      _this.props.onBlur();
      if (!validationOK || alreadyHandled) {
        return;
      }
      if (_this.props.cancelOnBlur) {
        _this.handleCancel();
      } else if (_this.props.confirmOnBlur) {
        _this.handleConfirm();
      } else {
        _this.setStateWithReadOnly(true);
      }
    };
    _this.handleFocus = function () {
      _this.setState({
        isFocused: !_this.state.isReadOnly
      });
    };
    _this.handleCancel = function (blurInput) {
      var callback = function callback() {
        _this.onChange();
        if (_.isFunction(blurInput)) {
          _this.alreadyHandled = true;
          blurInput();
        }
      };
      var newState = {
        valueCandidate: _this.props.value,
        isValid: true
      };
      _this.setStateWithReadOnly(true, newState, callback);
      _this.props.onCancel();
    };
    _this.handleConfirm = function (blurInput) {
      var validationOK = _this.state.isValid || _this.props.allowInvalidChange;
      if (!validationOK) {
        return;
      }
      var callback = function callback() {
        _this.onChange();
        if (_.isFunction(blurInput)) {
          _this.alreadyHandled = true;
          blurInput();
        }
      };
      _this.setStateWithReadOnly(true, {}, callback);
      _this.props.onConfirm();
    };
    _this.handleKeyDown = function (_ref3, blur) {
      var keyCode = _ref3.keyCode,
        key = _ref3.key;
      if (key === 'Enter' || keyCode === KEYS.ENTER) {
        _this.handleConfirm(blur);
      } else if (key === 'Escape' || keyCode === KEYS.ESC) {
        _this.handleCancel(blur);
      }
    };
    return _this;
  }
  _inherits(EditableUrl, _React$Component);
  return _createClass(EditableUrl, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          valueCandidate: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.getClassNames()
      }, /*#__PURE__*/React.createElement("div", {
        className: "address-bar-container"
      }, /*#__PURE__*/React.createElement(AddressBarMiniToolbar, null), /*#__PURE__*/React.createElement("div", {
        className: "url-container"
      }, /*#__PURE__*/React.createElement("span", {
        "data-hook": "domain",
        className: "domain",
        onClick: this.props.onDomainClick
      }, this.props.domain), /*#__PURE__*/React.createElement(TextInput, {
        dataHook: "input-editable-url",
        defaultInputClass: "input-editable-url",
        focus: false,
        onClick: this.props.onInputClick,
        isReadOnly: this.state.isReadOnly,
        value: this.state.valueCandidate,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        closeTooltipOnClickOutside: this.props.closeTooltipOnClickOutside,
        blurOnEscKey: false,
        blurOnEnterKey: false,
        autoSelect: this.props.autoSelect,
        onChange: this.handleCandidateChange,
        onValidationStatus: this.handleValidationStatusChange,
        onFocus: this.handleFocus,
        selectOnFocus: false,
        shouldTranslate: this.props.shouldTranslate,
        allowInvalidChange: true,
        validator: this.props.validator,
        isValid: this.props.isValid,
        invalidMessage: this.props.invalidMessage,
        syncDelay: this.props.syncDelay,
        tooltipInteractive: this.props.tooltipInteractive,
        preventBlur: !this.state.isValid && !this.props.allowInvalidChange,
        placeholder: this.props.placeholder
      }))), this.props.editButtons ? /*#__PURE__*/React.createElement("div", {
        className: "buttons-container",
        key: "buttonsContainer"
      }, this.state.isReadOnly ? null : /*#__PURE__*/React.createElement(BaseButton, {
        dataHook: "editable-url-btn-cancel",
        className: "btn-light btn-md btn-round editable-url-btn-cancel",
        onClick: this.handleCancel,
        key: "cancel"
      }, /*#__PURE__*/React.createElement(DismissBold, null)), this.state.isReadOnly ? null : /*#__PURE__*/React.createElement(BaseButton, {
        disabled: !this.state.isValid && !this.props.allowInvalidChange,
        dataHook: "editable-url-btn-apply",
        className: "btn-light btn-md btn-round editable-url-btn-apply",
        onClick: this.handleConfirm,
        key: "ok"
      }, /*#__PURE__*/React.createElement(ConfirmBold, null)), this.state.isReadOnly ? /*#__PURE__*/React.createElement(BaseButton, {
        dataHook: "btn-edit",
        className: "btn-light btn-edit",
        onClick: this.handleEdit,
        key: "edit",
        ellipsis: true
      }, this.props.translateIfNeeded(this.props.editButtonText)) : null) : null);
    }
  }]);
}(React.Component);
var validatorType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]);
EditableUrl.displayName = 'EditableUrl';
EditableUrl.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  domain: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onValueCandidateChange: PropTypes.func,
  editButtons: PropTypes.bool,
  editButtonText: function editButtonText(props, propName, componentName) {
    if (!props[propName] && props.editButtons) {
      return new Error("Required prop '".concat(propName, "' was not specified in '").concat(componentName, "'."));
    }
  },
  autoSelect: PropTypes.bool,
  confirmOnBlur: PropTypes.bool,
  cancelOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  validator: validatorType,
  invalidMessage: PropTypes.node,
  tooltipInteractive: PropTypes.bool,
  closeTooltipOnClickOutside: PropTypes.bool,
  onValidationStatus: PropTypes.func,
  allowInvalidChange: PropTypes.bool,
  syncDelay: PropTypes.number,
  isValid: PropTypes.bool,
  onDomainClick: PropTypes.func,
  onInputClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};
EditableUrl.defaultProps = {
  isReadOnly: false,
  value: '',
  onChange: _.noop,
  onBlur: _.noop,
  onValueCandidateChange: _.noop,
  editButtons: false,
  autoSelect: true,
  confirmOnBlur: true,
  cancelOnBlur: false,
  closeTooltipOnClickOutside: true,
  onValidationStatus: _.noop,
  placeholder: '',
  onDomainClick: _.noop,
  onInputClick: _.noop,
  onEditClick: _.noop,
  onCancel: _.noop,
  onConfirm: _.noop
};
export default compose(EditableUrl);